import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "./store";

/**
 * Typed react-redux hooks.
 *
 * react-redux v9 no longer has a global state type, so use these instead of
 * the bare useDispatch/useSelector: useAppSelector knows the store shape and
 * useAppDispatch accepts the thunks in src/actions.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
